<div
    dropdown
    class="d-flex align-items-center ms-1 ms-md-3"
    container="body"
    placement="bottom right">

    <div
        dropdownToggle
        class="d-flex align-items-center cursor-pointer">
        <i class="fa fa-medkit text-danger fs-4"></i>
        <i class="fa fa-angle-down text-gray-600 ms-1"></i>
    </div>

    <div
        *dropdownMenu
        class="dropdown-menu dropdown-menu-end py-2 px-0"
        style="min-width: 220px;">

        <!-- Loading State -->
        <div *ngIf="loading" class="text-center py-4">
            <span class="spinner-border spinner-border-sm align-middle"></span>
        </div>

        <!-- Empty State -->
        <div *ngIf="!loading && !hasNotifications" class="text-center py-4 px-4">
            <span class="text-muted fs-7">{{ l('NoRcopiaNotifications') }}</span>
        </div>

        <!-- Notifications List -->
        <ng-container *ngIf="!loading && hasNotifications">
            <a *ngFor="let notification of recopiaNotifications" href="javascript:;"
                class="dropdown-item d-flex align-items-center justify-content-between px-4 py-3"
                (click)="onNotificationClick(notification)">
                <span class="text-dark fw-bold fs-7">
                    {{ getNotificationLabel(notification.typeOfNotification) }}
                </span>
                <span class="fw-bolder text-dark fs-7 ms-3">
                    {{ notification.notificationNumber }}
                </span>
            </a>
        </ng-container>
    </div>
</div>

<rcopiaPopUpModal #rcopiaPopUpModal></rcopiaPopUpModal>